(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(function (root) {
  'use strict';
  const KEY = 'cc:xmas2026:pending';
  const TTL = 30 * 60 * 1000;
  const PATH = '/pages/weihnachtsgeschenke-firmen';
  const EVENT = 'cc:christmas_enquiry_success';
  const CANONICAL = 'https://www.collaborationcards.de' + PATH;

  function cleanLanding(href) {
    const source = new URL(href);
    const clean = new URL(CANONICAL);
    for (const key of ['gclid', 'gbraid', 'wbraid']) {
      const value = source.searchParams.get(key);
      if (value && /^[a-zA-Z0-9_-]{1,500}$/.test(value)) clean.searchParams.set(key, value);
    }
    return clean.href;
  }

  function explicitConsent(shopify) {
    try {
      const privacy = shopify.customerPrivacy;
      const consent = privacy.currentVisitorConsent();
      return consent.analytics === 'yes' && consent.marketing === 'yes' &&
        privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    } catch (_) { return false; }
  }

  function validPending(raw, now) {
    try {
      const item = JSON.parse(raw);
      return item && /^[a-f0-9-]{36}$/.test(item.id) &&
        Number.isFinite(item.created) && now >= item.created &&
        now - item.created < TTL ? item : null;
    } catch (_) { return null; }
  }

  function consume(options) {
    const { storage, status, consent, now, publish, isTest } = options;
    try {
      if (status !== 'success' || !consent || isTest) {
        storage.removeItem(KEY);
        return false;
      }
      const pending = validPending(storage.getItem(KEY), now);
      if (!pending) { storage.removeItem(KEY); return false; }
      storage.removeItem(KEY);
      publish(pending.test ? 'cc:christmas_enquiry_test' : EVENT, {
        submission_id: pending.id, campaign: 'weihnachten_2026',
        landing_url: cleanLanding(pending.landing || CANONICAL)
      });
      return true;
    } catch (_) { return false; }
  }

  function install(win) {
    if (win.location.pathname.replace(/\/$/, '') !== PATH) return;
    const form = win.document.getElementById('ContactForm');
    const state = win.document.getElementById('CCEnquiryState');
    if (!form || !state || form.dataset.ccEnquiryBound === 'true') return;
    form.dataset.ccEnquiryBound = 'true';
    const clear = () => { try { win.sessionStorage.removeItem(KEY); } catch (_) {} };
    const testVisit = new URL(win.location.href).searchParams.get('cc_tracking_test') === '1';
    let attempted = false;

    form.addEventListener('submit', (event) => {
      try {
        if (event.defaultPrevented || !form.checkValidity() ||
            !explicitConsent(win.Shopify)) { clear(); return; }
        win.sessionStorage.setItem(KEY, JSON.stringify({
          id: win.crypto.randomUUID(), created: Date.now(), test: testVisit,
          landing: cleanLanding(win.location.href)
        }));
      } catch (_) { clear(); }
    });

    function check() {
      if (!win.Shopify?.customerPrivacy) return;
      const consent = explicitConsent(win.Shopify);
      if (!consent) { clear(); return; }
      if (attempted) return;
      if (state.dataset.status !== 'success') { attempted = true; clear(); return; }
      if (typeof win.Shopify.analytics?.publish !== 'function') return;
      attempted = true;
      try {
        consume({ storage: win.sessionStorage, status: state.dataset.status,
          consent, now: Date.now(), isTest: state.dataset.test === 'true',
          publish: (name, data) => {
            win.Shopify.analytics.publish(name, data);
            state.dataset.event = name;
          } });
      } catch (_) { clear(); }
    }

    win.document.addEventListener('visitorConsentCollected', check);
    if (win.Shopify?.loadFeatures) {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => { if (!error) check(); });
    }
    check();
    let tries = 0;
    const timer = win.setInterval(() => {
      check();
      if (attempted || ++tries >= 20) win.clearInterval(timer);
    }, 250);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { KEY, TTL, explicitConsent, validPending, consume, install, cleanLanding };
  } else if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', () => install(root), { once: true });
    } else { install(root); }
  }
})(typeof window === 'undefined' ? {} : window);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
